// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__FL0dk","link":"footer_link__w4S0H"};